import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <div style={{
      background: '#080810',
      color: '#F5F5F0',
      fontFamily: 'Inter, sans-serif',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '500px',
        background: '#14141f',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: '24px',
        padding: '32px',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontFamily: 'Oswald, sans-serif',
          fontSize: '28px',
          letterSpacing: '2px',
          marginBottom: '8px'
        }}>
          PITAZO <span style={{ color: '#F0B429' }}>MUNDIAL</span>
        </h1>
        <p style={{ marginTop: '8px', color: '#888' }}>
          {t('contact_question') || '¿Preguntas, dudas o sugerencias?'}
        </p>

        <div style={{
          background: 'rgba(240,180,41,0.1)',
          border: '1px solid rgba(240,180,41,0.2)',
          borderRadius: '16px',
          padding: '20px',
          margin: '24px 0'
        }}>
          <div style={{ fontSize: '12px', color: '#888', marginBottom: '8px' }}>
            📧 {t('contact_write_us') || 'ESCRÍBENOS A'}
          </div>
          <div style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#F0B429',
            wordBreak: 'break-all'
          }}>
            jandres1cxs@gmail.com
          </div>
          <div style={{ fontSize: '11px', color: '#666', marginTop: '12px' }}>
            {t('contact_response_time') || 'Respondemos en 24-48 horas'}
          </div>
        </div>

        <Link to="/" style={{
          display: 'inline-block',
          marginTop: '16px',
          color: '#F0B429',
          textDecoration: 'none',
          fontSize: '14px'
        }}>
          ← {t('back_to_home')}
        </Link>

        <div style={{ marginTop: '24px', fontSize: '12px', color: '#666' }}>
          Pitazo Mundial - {t('contact_subtitle') || 'La mejor app de pronósticos para el Mundial 2026'}
        </div>
      </div>
    </div>
  );
};

export default Contact;